import React from 'react';

const CashSummaryReportHeader = () => (
    <h1>Cash Summary Report</h1>
);

export default CashSummaryReportHeader;
